import { DateTime } from 'luxon';

const TZ = 'Asia/Kolkata';

const parse = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return DateTime.fromJSDate(dateStr).setZone(TZ);
  const s = String(dateStr);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return DateTime.fromISO(s, { zone: TZ });
  }
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
    return DateTime.fromSQL(s, { zone: TZ });
  }
  return DateTime.fromISO(s, { setZone: true }).setZone(TZ);
};

export const formatDate = (dateStr) => {
  const dt = parse(dateStr);
  return dt && dt.isValid ? dt.toFormat('d MMM yyyy') : null;
};

export const formatShortDate = (dateStr) => {
  const dt = parse(dateStr);
  return dt && dt.isValid ? dt.toFormat('MMM d') : null;
};

export const formatTime = (dateStr) => {
  const dt = parse(dateStr);
  return dt && dt.isValid ? dt.toFormat('hh:mm a') : null;
};

export const formatDateTime = (dateStr) => {
  const dt = parse(dateStr);
  return dt && dt.isValid ? dt.toFormat('d MMM yyyy, hh:mm a') : null;
};

export const timeAgo = (dateStr) => {
  const dt = parse(dateStr);
  if (!dt || !dt.isValid) return '';
  const diff = DateTime.now().setZone(TZ).diff(dt, 'seconds').seconds;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return dt.toFormat('d MMM yyyy');
};

export const isDateOverdue = (targetDateStr) => {
  const dt = parse(targetDateStr);
  if (!dt || !dt.isValid) return false;
  const today = DateTime.now().setZone(TZ).startOf('day');
  return dt.startOf('day') <= today;
};

export const todayISODate = () => DateTime.now().setZone(TZ).toFormat('yyyy-MM-dd');

export const currentYear = () => DateTime.now().setZone(TZ).year;

export const inputDateOrDefault = (dateStr) => {
  const dt = parse(dateStr);
  if (!dt || !dt.isValid) return todayISODate();
  return dt.toFormat('yyyy-MM-dd');
};
